import { ChangeDetectionStrategy, Component, Directive, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    host: { 'class': 'app-card' },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppCard{
}

@Component({
    selector: 'app-card-header',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'class': 'app-card-header' },
    template: `
    <div class="app-card-header-heading-group">
      <ng-content select="app-card-header-heading"></ng-content>
      <ng-content select="app-card-header-subheading"></ng-content>
    </div>
    <ng-content></ng-content>
    <ng-content select="app-card-header-actions"></ng-content>
  `,
    standalone: false
})
export class AppCardHeader {
}

@Component({
    selector: 'app-card-content',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'class': 'app-card-content' },
    template: `
    <ng-content></ng-content>`,
    standalone: false
})
export class AppCardContent {
}

// noinspection TsLint
@Directive({
    selector: 'app-card-header-heading',
    host: { 'class': 'app-card-header-heading' },
    standalone: false
})
export class AppCardHeaderTitle {
}

// noinspection TsLint
@Directive({
    selector: 'app-card-header-subheading',
    host: { 'class': 'app-card-header-subheading' },
    standalone: false
})
export class AppCardHeaderSubTitle {
}

// noinspection TsLint
@Directive({
    selector: 'app-card-header-actions',
    host: { 'class': 'app-card-header-actions' },
    standalone: false
})
export class AppCardHeaderActions {
}

// noinspection TsLint
@Directive({
    selector: 'app-card-actions',
    host: {
        'class': 'app-card-actions',
        '[class.app-card-actions-align-end]': 'align === "end"',
    },
    standalone: false
})
export class AppCardActions {
  /** Position of the actions inside the card. */
  @Input() align: 'start' | 'end' = 'start';
}